// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__11oVO","footer":"Form_footer__22zTL"};